<p>patient-detail works!</p>
